export function slotsForDate(medico, dIso) {
  const wd = String((new Date(dIso + "T00:00:00").getDay() + 6) % 7);
  const periods = (medico?.schedule_periods || []).filter((p) => p.start <= dIso && (!p.end || dIso <= p.end));
  if (periods.length) {
    const p = periods.reduce((a, b) => (b.start > a.start ? b : a));
    return p.weekly_slots[wd] || [];
  }
  return (medico?.weekly_slots || {})[wd] || [];
}
